import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import "./Navbar.css";
import resume from "../../img/Resume.pdf";
import { motion } from "framer-motion";

const Navbar = () => {
  return (
    <motion.nav
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeIn", delay: 0.5 }}
      className="sticky top-0 left-0 bg-[#1A120B] z-[99] py-4 sm:pt-0 sm:h-[80px]"
    >
      <h1 className="m-3 w-full text-3xl text-left font-bold text-[#00df9a]">
        <Link to="/" smooth>
          A
        </Link>
      </h1>
      <ul className=" hidden md:flex">
        <li>
          <Link to="#about" smooth>
            About
          </Link>
        </li>

        <li>
          <Link to="#work" smooth>
            Work
          </Link>
        </li>
        {/* <li>
          <Link to="#skills" smooth>
            Skills
          </Link>
        </li> */}

        <li>
          <Link to="#contact" smooth>
            Contact
          </Link>
        </li>
        <li>
          <button>
            {" "}
            <a href={resume} download="Abhishek Resume">
              Resume
            </a>
          </button>{" "}
        </li>
      </ul>
    </motion.nav>

    // </div>
  );
};

export default Navbar;
